import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  {
    path: 'polityka-prywatnosci',
    loadComponent: () => import('./pages/privacy/privacy.component').then((m) => m.PrivacyComponent),
  },
  {
    path: 'regulamin',
    loadComponent: () => import('./pages/terms/terms.component').then((m) => m.TermsComponent),
  },
  {
    path: 'admin',
    children: [
      { path: '', redirectTo: 'moje-quizy', pathMatch: 'full' },
      {
        path: 'kreator',
        loadComponent: () => import('./pages/creator/creator.component').then((m) => m.CreatorComponent),
      },
      {
        path: 'kreator/:id',
        loadComponent: () => import('./pages/creator/creator.component').then((m) => m.CreatorComponent),
      },
      {
        path: 'moje-quizy',
        loadComponent: () => import('./pages/quizzes/quizzes.component').then((m) => m.QuizzesComponent),
      },
      {
        path: 'quiz/:id',
        loadComponent: () =>
          import('./pages/quiz-detail/quiz-detail.component').then((m) => m.QuizDetailComponent),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
